import React from "react";
import { Link } from "react-router-dom";
import Navbar from "./navbar";
import Footer from "./footer";
import HtmlContent, { PhotoLink } from "./HtmlContent";
import { mediaUrl } from "../lib/siteApi";

export default function PageLayout({
  eyebrow,
  title,
  summary,
  image,
  crumbs = [],
  backTo,
  roomy = false,
  compact = false,
  children,
  related = [],
}) {
  return (
    <>
      <Navbar />
      <section className={`relative overflow-hidden pb-12 bg-gradient-to-br from-slate-950 via-teal-950 to-emerald-900 text-white ${roomy ? "pt-48 sm:pt-56" : "pt-28"}`}>
        <div className="absolute inset-0 opacity-30" style={{ backgroundImage: 'url("https://www.transparenttextures.com/patterns/cubes.png")' }} />
        <div className="container relative z-10">
          {backTo ? (
            <Link to={backTo} className="mb-6 inline-flex items-center gap-2 text-sm font-semibold text-teal-200 hover:text-white">← Back</Link>
          ) : crumbs.length > 0 ? (
            <nav className="mb-6 flex flex-wrap items-center gap-2 text-sm text-teal-100/80">
              <Link to="/" className="hover:text-white">Home</Link>
              {crumbs.map((crumb) => (
                <span key={crumb.label} className="flex items-center gap-2">
                  <span className="text-teal-500">/</span>
                  {crumb.to ? <Link to={crumb.to} className="hover:text-white">{crumb.label}</Link> : <span className="text-white">{crumb.label}</span>}
                </span>
              ))}
            </nav>
          ) : null}
          {eyebrow ? <p className={`mb-3 text-teal-300 ${compact ? "project-kicker" : "renerg-kicker"}`}>{eyebrow}</p> : null}
          <h1 className={`max-w-4xl text-white ${compact ? "project-title" : "renerg-section"}`}>{title}</h1>
          {summary ? <div className="renerg-body mt-4 max-w-3xl text-teal-50/90"><HtmlContent html={summary} /></div> : null}
        </div>
      </section>
      <section className="bg-slate-50 py-12 lg:py-16">
        <div className="container">
          {image ? (
            <PhotoLink to={crumbs[crumbs.length - 1]?.to || "/"} src={mediaUrl(image)} alt={title} className="mb-10 max-h-[420px] w-full rounded-3xl object-cover shadow-xl" wrapClassName="rounded-3xl mb-10" />
          ) : null}
          {children}
          {related.length > 0 && (
            <div className="mt-16">
              <h2 className="renerg-h3 mb-6 text-slate-900">Keep exploring</h2>
              <div className="grid gap-6 md:grid-cols-3">
                {related.map((item) => (
                  <Link key={item.to} to={item.to} className="group overflow-hidden rounded-2xl bg-white shadow-md transition hover:-translate-y-1 hover:shadow-xl">
                    {item.image ? <img src={mediaUrl(item.image)} alt="" className="h-40 w-full object-cover" /> : <div className="h-24 bg-gradient-to-r from-teal-600 to-emerald-700" />}
                    <div className="p-5">
                      <p className="project-kicker text-teal-700">{item.kicker}</p>
                      <h3 className="project-card-title mt-1 text-slate-900 group-hover:text-teal-700">{item.title}</h3>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          )}
          <div className="mt-16 overflow-hidden rounded-3xl bg-gradient-to-r from-teal-700 to-emerald-800 p-8 text-white lg:flex lg:items-center lg:justify-between">
            <div>
              <p className="text-sm uppercase tracking-[0.2em] text-teal-100">Talk to RENERG</p>
              <h2 className="renerg-h3 mt-2 text-white">Ready for a solar, building or e-mobility project?</h2>
            </div>
            <Link to="/contact" className="mt-6 inline-flex rounded-xl bg-white px-6 py-3 font-semibold text-teal-800 shadow-lg lg:mt-0">Contact us</Link>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
